import { render } from "./lock.vue?vue&type=template&id=68bfb470&scoped=true"
import script from "./lock.vue?vue&type=script&lang=js"
export * from "./lock.vue?vue&type=script&lang=js"

import "./lock.vue?vue&type=style&index=0&id=68bfb470&lang=scss&scoped=true"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68bfb470"]])

export default __exports__